// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const FlowChart: MarkdocTagRegistration = {
  tag: 'flow-chart',
  component: 'FlowChart',
  attributes: {
    type: {
      type: String,
    },
  },
};
